import { RouterModule, Routes } from '@angular/router';
import { DisponibilidadPlanificacionNormalListarComponent } from './disponibilidad-planificacion-normal-listar/disponibilidad-planificacion-normal-listar.component';
import { DisponibilidadPlanificacionNormalCrearComponent } from './disponibilidad-planificacion-normal-crear/disponibilidad-planificacion-normal-crear.component';
import { DisponibilidadPlanificacionExcepcionalListarComponent } from './disponibilidad-planificacion-excepcional-listar/disponibilidad-planificacion-excepcional-listar.component';
import { DisponibilidadPlanificacionExcepcionalCrearComponent } from './disponibilidad-planificacion-excepcional-crear/disponibilidad-planificacion-excepcional-crear.component';
import { AsociarJefeDependenciaComponent } from './asociar-jefe-dependencia/asociar-jefe-dependencia.component';
import { AgregarJefeDependenciaComponent } from './agregar-jefe-dependencia/agregar-jefe-dependencia.component';
import { ConfiguracionParametrosComponent } from './configuracion-parametros/configuracion-parametros.component';
import { ConfiguracionParametrosEditarComponent } from './configuracion-parametros-editar/configuracion-parametros-editar.component';



//import { SarGeneralGuard } from './guards/sar-general.guard';



const pagesRoutes: Routes = [

  {
    path: 'disponibilidad-planificacion-normal-listar'
    , component: DisponibilidadPlanificacionNormalListarComponent

  },
  {
    path: 'disponibilidad-planificacion-normal-crear'
    , component: DisponibilidadPlanificacionNormalCrearComponent

  },
  {
    path: 'disponibilidad-planificacion-normal-crear/:idDisponibilidadPlanificacion'
    , component: DisponibilidadPlanificacionNormalCrearComponent

  },
  {
    path: 'disponibilidad-planificacion-excepcional-listar'
    , component: DisponibilidadPlanificacionExcepcionalListarComponent

  },
  {
    path: 'disponibilidad-planificacion-excepcional-crear'
    , component: DisponibilidadPlanificacionExcepcionalCrearComponent

  },
  {
    path: 'disponibilidad-planificacion-excepcional-crear/:idDisponibilidad'
    , component: DisponibilidadPlanificacionExcepcionalCrearComponent
  },
  {
    path: 'asociar-jefe-dependencia'
    , component: AsociarJefeDependenciaComponent
  },
  {
    path: 'agregar-jefe-dependencia-crear'
    , component: AgregarJefeDependenciaComponent
  },
  {
    path: 'agregar-jefe-dependencia-editar/:idAsociacionPersona', component: AgregarJefeDependenciaComponent
  },
  {
    path: 'configuracion-parametros'
    , component: ConfiguracionParametrosComponent
  },
  {
    path: 'configuracion-parametros-editar'
    , component: ConfiguracionParametrosEditarComponent
  }
];

export const CONFIGURACION_ROUTES = RouterModule.forChild(pagesRoutes);